"use client";
import React from "react";

import Container from "@mui/material/Container";

import { ArticlePageGenericButtonProps } from "~/bff/components/ArticlePageGenericButton";
import { CombinedButtonDS } from "~/components/combined-button-ds/component";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

export const ArticlePageGenericButton: React.FC<ArticlePageGenericButtonProps> = ({
  text,
  url,
  testAutomationId = "article-page-generic-button",
}) => {
  const idValue = `${testAutomationId}-${text?.replace(/ /g, "-").toLowerCase()}`;
  return (
    <Container
      sx={{ display: "flex", justifyContent: "center", my: { xs: 4, sm: 8 } }}
      id={idValue}
      {...getTestAutomationProps(testAutomationId)}
    >
      <CombinedButtonDS
        href={url ?? ""}
        variant="primary"
        size="medium"
        role="button"
      >
        {text}
      </CombinedButtonDS>
    </Container>
  );
};
